

$(function() {
  "use strict";
  
  $('.has-dropdown').on('mouseenter', function(){
      theme.repositionDropdown($(this).find('.dropdown'));
  });
  $('.has-dropdown').on('mouseleave', function(){
      theme.resetDropdown($(this).find('.dropdown'));
  });
  
  $('.toggle-menu').on('click', function(e) {
    e.preventDefault();
  	$('#mobile-menu').toggleClass('open');
  });
  
  $('.toggle-filters').on('click', function(e) {
    e.preventDefault();
  	$('#mobile-filters').toggleClass('open');
  });
  
  $('.toggle-accordion').on('click', function(e) {
    e.preventDefault();
  	$(this).toggleClass('active').next('.accordion').toggleClass('open');
  });
  
});

theme.repositionDropdown = function($dropdown) {
  var windowWidth, dropdownOffsetLeft, dropdownOffsetRight, dropdownWidth, containerWidth, containerOffsetLeft, containerOffsetRight, containerPadding, visibleDropdownWidth, offScreenDropdown;

  windowWidth 		= $(window).width();
  dropdownWidth 		= $dropdown.innerWidth();
  containerWidth 		= $('.navigation-wrapper > .container').length > 0 ? $('.navigation-wrapper > .container').width() : $('.navigation-wrapper > .container-fluid').width();
  containerInnerWidth = $('.navigation-wrapper > .container').length > 0 ? $('.navigation-wrapper > .container').innerWidth() : $('.navigation-wrapper > .container-fluid').innerWidth();

  dropdownOffsetLeft 	 = $dropdown.offset().left;
  dropdownOffsetRight  = (windowWidth - (dropdownOffsetLeft + dropdownWidth));
  containerOffsetLeft  = $('.navigation-wrapper > .container').length > 0 ? $('.navigation-wrapper > .container').offset().left : $('.navigation-wrapper > .container-fluid').offset().left;
  containerOffsetRight = (windowWidth - (containerOffsetLeft + containerInnerWidth));

  containerPadding 	 = (containerInnerWidth - containerWidth) / 2;
  dropdownPlusOffsetRight = windowWidth - dropdownOffsetLeft;
  offScreenDropdown  	 = dropdownWidth - dropdownPlusOffsetRight;

  //690 930 1110
  if (windowWidth > 767) {
      if (theme.isFullDropdown(dropdownWidth)) {
          $dropdown.css('left', (dropdownOffsetLeft+offScreenDropdown)/-2);
      }

      if ((!theme.isFullDropdown(dropdownWidth)) && (dropdownOffsetLeft < 30)) {
          $dropdown.css('right','auto');
          $dropdown.css('left','0');
          console.log('Left');
      }

      if ((!theme.isFullDropdown(dropdownWidth)) && (dropdownOffsetRight < 30)) {
          $dropdown.css('right','0');
          $dropdown.css('left','auto');
          console.log('Right');
      }
  }
}

theme.resetDropdown = function($dropdown) {
    $dropdown.css('left', 'auto');
}

theme.isFullDropdown = function(dropdownWidth) {
    if (dropdownWidth == 690 || dropdownWidth == 930 || dropdownWidth == 1110) {
        return true;
    } else {
        return false;
    }
}